<template>
  <section class="dp-layout">

    <section class="dp-left">
      <DepartmentPane directory-scope="internal" @tree-node-click="treeNodeClick"></DepartmentPane>
    </section>

    <section class="dp-right">
      <div class="teacher-kq-tab-bar">
        <el-tabs v-model="activeTab" class="teacher-kq-tabs" @tab-click="handleTabClick">
          <el-tab-pane label="迟到" name="late"></el-tab-pane>
          <el-tab-pane label="早退" name="equit"></el-tab-pane>
          <el-tab-pane label="缺勤" name="miss"></el-tab-pane>
        </el-tabs>
      </div>

      <!--工具条-->
      <toolbar ref="toolbar" :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

      <!--列表-->
      <div class="tbl-scroll-host">
      <el-table :data="users" v-loading="listLoading" size="medium" style="width: 100%" class="custom-tbl teacher-kq-tbl" height="100%">
        <el-table-column prop="UserName" label="姓名" width=""></el-table-column>
        <!-- <el-table-column prop="WorkNumber" label="工号" width=""></el-table-column> -->
        <el-table-column prop="DeptName" label="部门" width=""></el-table-column>
        <el-table-column prop="KaoqinMonth" label="月份" width=""></el-table-column>
        <el-table-column :label="currentCountLabel" width="">
          <template slot-scope="scope">
            <el-button
              v-if="currentCount(scope.row) > 0"
              type="text"
              size="small"
              class="count-link count-link--danger"
              @click.stop="showDayDetail(scope.row)">
              {{ currentCount(scope.row) }}
            </el-button>
            <span v-else>{{ currentCount(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="正常天数" width="">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.NormalCount > 0"
              type="text"
              size="small"
              class="count-link count-link--success"
              @click.stop="showDayDetail(scope.row, 'normal')">
              {{ scope.row.NormalCount }}
            </el-button>
            <span v-else>{{ scope.row.NormalCount || 0 }}</span>
          </template>
        </el-table-column>
      </el-table>
      </div>

      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange"
          :page-size="10" :total="total" style="float: right"></el-pagination>
      </el-col>

      <!-- 当月明细弹窗 -->
      <el-dialog
        :title="detailDialogTitle"
        :visible.sync="detailVisible"
        width="70%"
        center
        top="5vh"
        @close="detailVisible = false">
        <el-table :data="detailList" v-loading="detailLoading" class="custom-tbl"
          style="width: 100%" max-height="480">
          <template slot="empty">
            <span style="color:#909399">暂无{{ detailTypeLabel }}日期</span>
          </template>
          <el-table-column prop="KaoqinDate" label="考勤日期" width></el-table-column>
          <el-table-column label="第1次" width>
            <template slot-scope="scope">
              <span v-if="scope.row.RegTime1" :style="{ color: getStatusColor(scope.row.RegStatus1) }">{{ scope.row.RegTime1 }}</span>
              <span v-else style="color:#c0c4cc">-</span>
            </template>
          </el-table-column>
          <el-table-column label="第2次" width>
            <template slot-scope="scope">
              <span v-if="scope.row.RegTime2" :style="{ color: getStatusColor(scope.row.RegStatus2) }">{{ scope.row.RegTime2 }}</span>
              <span v-else style="color:#c0c4cc">-</span>
            </template>
          </el-table-column>
          <el-table-column label="第3次" width>
            <template slot-scope="scope">
              <span v-if="scope.row.RegTime3" :style="{ color: getStatusColor(scope.row.RegStatus3) }">{{ scope.row.RegTime3 }}</span>
              <span v-else style="color:#c0c4cc">-</span>
            </template>
          </el-table-column>
          <el-table-column label="第4次" width>
            <template slot-scope="scope">
              <span v-if="scope.row.RegTime4" :style="{ color: getStatusColor(scope.row.RegStatus4) }">{{ scope.row.RegTime4 }}</span>
              <span v-else style="color:#c0c4cc">-</span>
            </template>
          </el-table-column>
          <el-table-column label="第5次" width>
            <template slot-scope="scope">
              <span v-if="scope.row.RegTime5" :style="{ color: getStatusColor(scope.row.RegStatus5) }">{{ scope.row.RegTime5 }}</span>
              <span v-else style="color:#c0c4cc">-</span>
            </template>
          </el-table-column>
          <el-table-column label="第6次" width>
            <template slot-scope="scope">
              <span v-if="scope.row.RegTime6" :style="{ color: getStatusColor(scope.row.RegStatus6) }">{{ scope.row.RegTime6 }}</span>
              <span v-else style="color:#c0c4cc">-</span>
            </template>
          </el-table-column>
          <el-table-column prop="DailyKaoqinStatus" label="状态" width>
            <template slot-scope="scope">
              <span v-if="!scope.row.DailyKaoqinStatus" style="color:#c0c4cc">-</span>
              <el-tag v-else :type="getDailyStatusTagType(scope.row.DailyKaoqinStatus)" size="mini">
                {{ getDailyStatusLabel(scope.row.DailyKaoqinStatus) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="80">
            <template slot-scope="scope">
              <el-button class="table-op-link" type="text" size="small" @click.stop="showHistory(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-button @click="detailVisible = false">关 闭</el-button>
        </div>
        </el-dialog>

      <!-- 当日打卡详情 -->
      <el-dialog title="考勤详情记录" :visible.sync="historyDialogVisible" width="40%" center
        @close="historyDataHandleClose">
        <el-table :data="historyData" class="custom-tbl" style="width: 100%">
          <el-table-column prop="TouchTime" label="打卡时间" width></el-table-column>
          <el-table-column prop="ReportTime" label="上报时间" width></el-table-column>
          <el-table-column prop="TouchType" label="方向" width="80"></el-table-column>
          <el-table-column prop="RegStatus" label="状态" width="80"></el-table-column>
          <el-table-column label="考勤终端" width>
            <template slot-scope="scope">
              {{ scope.row.KqTerminalId || scope.row.TouchPosition || '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="ProcessResult" label="处理情况" width></el-table-column>
          <el-table-column prop="KqImageFile" label="媒体文件" align="center" header-align="center" width="120">
            <template slot-scope="scope">
              <oss-media-thumbs :media="scope.row.KqImageFile" />
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-container">
          <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleHistoryDataChange"
            :page-size="10" :total="historyDataTotal" style="float: right"></el-pagination>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="historyDialogVisible = false">关 闭</el-button>
        </div>
      </el-dialog>
    </section>
  </section>
</template>


<script>
import { getTeacherMonthDetail, getTeacherMonthRecords, getTeacherRecordDetail, exportTeacherLateRecords } from "../../api/teacherAttendance";
import { getCampusList } from '../../api/modules/misc';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from "../../components/DepartmentPane";

const STATUS_MAP = { late: "late", equit: "equit", miss: "miss" };

export default {
  components: { Toolbar, DepartmentPane },
  data() {
    return {
      activeTab: "late",
      filters: {},
      searchList: [
        { label: "选择校区", key: "campusId", type: "select", clearable: true, options: [] },
        { label: "姓名", key: "name" },
        { label: "月份", key: "date", type: "month" },
      ],
      buttonList: [],
      users: [],
      total: 0,
      page: 1,
      listLoading: false,
      DepartmentId: 0,
      // 明细弹窗
      detailVisible: false,
      detailLoading: false,
      detailList: [],
      detailDialogTitle: "",
      detailTeacherId: "",
      detailType: "late",
      historyDialogVisible: false,
      historyData: [],
      historyDataTotal: 0,
      historyDataPage: 1,
      historyDate: "",
    };
  },
  computed: {
    currentCountLabel() {
      const map = { late: "迟到天数", equit: "早退天数", miss: "缺勤天数" };
      return map[this.activeTab] || "天数";
    },
    detailTypeLabel() {
      const map = { late: "迟到", equit: "早退", miss: "缺勤", normal: "正常" };
      return map[this.detailType] || "";
    },
  },
  methods: {
    currentCount(row) {
      const map = { late: row.LateCount, equit: row.EquitCount, miss: row.MissCount };
      return map[this.activeTab] || 0;
    },
    treeNodeClick(data) {
      this.DepartmentId = data.value;
      this.clearCampusFilter();
      this.loadCampusOptions();
      this.page = 1;
      this.handleQuery(false);
    },
    /** 取顶部当前学校 ID（校区列表必须按学校加载，不能用内部部门 ID）。 */
    resolveSchoolId() {
      const candidates = [
        this.$store.state.activeSchoolId,
        typeof window !== 'undefined' ? window.localStorage.getItem('activeSchoolId') : '',
      ];
      return candidates.find((id) => /^\d+$/.test(String(id || '')) && String(id) !== '0') || '';
    },
    /** 清空工具栏校区筛选（切换学校时防止残留旧校区）。最后更新：2026-08-30 */
    clearCampusFilter() {
      this.filters = { ...(this.filters || {}), campusId: null };
      const campusSearch = this.searchList.find((e) => e.key === 'campusId');
      if (campusSearch) campusSearch.options = [];
      if (this.$refs.toolbar && this.$refs.toolbar.searchObj) {
        this.$set(this.$refs.toolbar.searchObj, 'campusId', null);
      }
    },
    /** 顶部学校切换后重载校区。最后更新：2026-08-30 */
    onActiveSchoolChange(newSchoolId, oldSchoolId) {
      if (String(newSchoolId || '') === String(oldSchoolId || '')) return;
      this.clearCampusFilter();
      this.users = [];
      this.total = 0;
      this.page = 1;
      this.DepartmentId = 0;
      this.detailVisible = false;
      this.loadCampusOptions();
    },
    loadCampusOptions() {
      const schoolId = this.resolveSchoolId();
      if (!schoolId) {
        const campusSearch = this.searchList.find((e) => e.key === 'campusId');
        if (campusSearch) campusSearch.options = [];
        return;
      }
      getCampusList({ page: 1, intPageSize: 999, departmentId: schoolId }).then((res) => {
        if (String(schoolId) !== String(this.resolveSchoolId())) return;
        if (!res.data.success) return;
        const list = res.data.response.data || [];
        const options = list.map((d) => ({ label: d.Name, value: d.Id }));
        const campusSearch = this.searchList.find((e) => e.key === 'campusId');
        if (campusSearch) campusSearch.options = options;
      });
    },
    handleTabClick() {
      this.page = 1;
      this.handleQuery(false);
    },
    callFunction(item) {
      if (typeof item.search === "object") {
        this.filters = item.search;
      }
      this[item.Func] && this[item.Func].apply(this, item);
    },
    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery(false);
    },
    handleQuery(resetPage = true) {
      if (resetPage) this.page = 1;
      const para = {
        page: this.page,
        departmentId: this.filters.campusId || this.DepartmentId || "",
        name: this.filters.name,
        date: this.filters.date,
      };
      this.listLoading = true;
      getTeacherMonthDetail(para).then((res) => {
        const all = res.data.response.data || [];
        const filtered = all.filter((r) => this.currentCount(r) > 0);
        this.total = filtered.length;
        this.users = filtered;
        this.listLoading = false;
      }).catch(() => { this.listLoading = false; });
    },
    /** 点击天数弹出当月每日明细，过滤出对应状态的日期 */
    showDayDetail(row, type) {
      const detailType = type || this.activeTab;
      this.detailType = detailType;
      const tabLabel = this.detailTypeLabel;
      this.detailDialogTitle = `${row.UserName} · ${row.KaoqinMonth || this.filters.date || ""} · ${tabLabel}明细`;
      this.detailTeacherId = row.UserId;
      this.detailVisible = true;
      this.detailLoading = true;
      this.detailList = [];
      const monthDate = row.KaoqinMonth || this.filters.date;
      getTeacherMonthRecords({ userId: row.UserId, date: monthDate }).then((res) => {
        const all = res.data.response || [];
        if (detailType === "miss") {
          // 缺勤：无打卡记录（status 为空）或明确标记为 miss 的日期均算缺勤
          this.detailList = all.filter((d) => !d.DailyKaoqinStatus || d.DailyKaoqinStatus === "miss");
        } else if (detailType === "normal") {
          this.detailList = all.filter((d) => d.DailyKaoqinStatus === "normal");
        } else {
          this.detailList = all.filter((d) => d.DailyKaoqinStatus === STATUS_MAP[detailType]);
        }
        this.detailLoading = false;
      }).catch(() => { this.detailLoading = false; });
    },
    showHistory(row) {
      this.historyDate = row.KaoqinDate;
      this.historyDataPage = 1;
      this.handleHistoryDataQuery();
    },
    handleHistoryDataChange(val) {
      this.historyDataPage = val;
      this.handleHistoryDataQuery();
    },
    handleHistoryDataQuery() {
      const para = {
        page: this.historyDataPage,
        intPageSize: 10,
        userId: this.detailTeacherId,
        date: this.historyDate,
        endDate: this.historyDate,
      };
      getTeacherRecordDetail(para).then(async (res) => {
        if (!res.data.success) {
          this.$message({ message: res.data.msg || "查询失败", type: "error" });
          return;
        }
        const resp = res.data.response || {};
        this.historyDataTotal = resp.dataCount || 0;
        const rows = resp.data || [];
        await this.prefetchListOssMedia(rows, "KqImageFile");
        this.historyData = rows;
        this.$nextTick(() => { this.historyDialogVisible = true; });
      });
    },
    historyDataHandleClose() {
      this.historyData = [];
      this.historyDataTotal = 0;
      this.historyDataPage = 1;
      this.historyDate = "";
    },
    getDailyStatusLabel(status) {
      const map = { normal: "正常", late: "迟到", equit: "早退", miss: "缺勤", leave: "请假" };
      return map[status] || status || "-";
    },
    getDailyStatusTagType(status) {
      const map = { normal: "success", late: "warning", equit: "danger", miss: "danger", leave: "info" };
      return map[status] || "";
    },
    getStatusColor(status) {
      return status && status !== "normal" ? "#f56c6c" : "";
    },
    /** 导出当前 Tab 异常统计（迟到/早退/缺勤） */
    async exportExcel() {
      const tabLabelMap = { late: "迟到", equit: "早退", miss: "缺勤" };
      const tabLabel = tabLabelMap[this.activeTab] || "异常";
      try {
        const para = {
          departmentId: this.filters.campusId || this.DepartmentId || "",
          name: this.filters.name,
          date: this.filters.date,
          abnormalType: this.activeTab,
        };
        const response = await exportTeacherLateRecords(para);
        if (!response.data) {
          this.$message({ message: "导出数据为空", type: "error" });
          return;
        }
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `教师${tabLabel}统计.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (e) {
        console.error("导出失败:", e);
        this.$message({ message: "导出失败", type: "error" });
      }
    },
  },
  watch: {
    "$store.state.activeSchoolId"(newSchoolId, oldSchoolId) {
      this.onActiveSchoolChange(newSchoolId, oldSchoolId);
    },
  },
  mounted() {
    const routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    if (!this.buttonList.some((b) => b.Func === "handleQuery")) {
      this.buttonList.unshift({ name: "查询", Func: "handleQuery", id: 999 });
    }
    if (!this.buttonList.some((b) => b.Func === "exportExcel")) {
      this.buttonList.push({ name: "导出", Func: "exportExcel", id: 998 });
    }
    this.loadCampusOptions();
  },
};
</script>

<style scoped>
.teacher-kq-tab-bar {
  flex-shrink: 0;
  margin-bottom: 0;
}

.teacher-kq-tab-bar >>> .el-tabs__header {
  margin: 0 0 8px;
}

.teacher-kq-tab-bar >>> .el-tabs__content {
  display: none;
}

.count-link {
  font-weight: 600;
  padding: 4px 8px;
}

.count-link--danger {
  color: var(--btn-danger, #dc2626) !important;
}

.count-link--success {
  color: var(--btn-success, #059669) !important;
}
</style>
